export default __webpack_public_path__ + "static/media/dividerMobile.07033956.svg";